// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[8].use[1]!../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[8].use[2]!../../../../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[8].use[3]!../../../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[8].use[4]!../../../../../../node_modules/antd/dist/reset.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.AcademicWorks_App__ZfcEp {
  width: 100%;
}

/* Global Toast / Message enhancements */
.AcademicWorks_ant-message__53yWu {
  top: 72px !important;
  z-index: 99999 !important;
}
.AcademicWorks_ant-message__53yWu .AcademicWorks_ant-message-notice-content__oWcAc {
  border-radius: 10px !important;
  padding: 10px 18px !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.08) !important;
  font-size: 13.5px !important;
  font-weight: 500 !important;
}

.AcademicWorks_ant-notification__Ru6UB {
  top: 72px !important;
  z-index: 99999 !important;
}

/* Standalone Toast Keyframes */
@keyframes AcademicWorks_toast-progress__5ej4f {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}
@keyframes AcademicWorks_toast-slide-in__jC85O {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.AcademicWorks_animate-toast-in__Zqtv4 {
  animation: AcademicWorks_toast-slide-in__jC85O 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.AcademicWorks_academic-work__fYqan .AcademicWorks_tabs-mobile__g89PO {
  display: none;
}
@media only screen and (max-width: 900px) {
  .AcademicWorks_academic-work__fYqan .AcademicWorks_tabs-landscape__2CXQE {
    display: none !important;
  }
  .AcademicWorks_academic-work__fYqan .AcademicWorks_tabs-mobile__g89PO {
    display: block !important;
  }
  .AcademicWorks_academic-work__fYqan .AcademicWorks_tabs-mobile__wrapper__x5kBj {
    box-shadow: rgba(0, 0, 0, 0.25) 0px 0px 10px 0px;
    border-radius: 10px;
  }
  .AcademicWorks_academic-work__fYqan .AcademicWorks_tabs-mobile__wrapper__x5kBj .ant-tabs-nav {
    border-radius: 10px 10px 0 0;
    overflow: hidden;
  }
  .AcademicWorks_academic-work__fYqan .AcademicWorks_tabs-mobile__wrapper__x5kBj .ant-tabs-nav-operations {
    display: none !important;
  }
  .AcademicWorks_academic-work__fYqan .AcademicWorks_tabs-mobile__wrapper__x5kBj .ant-tabs-tab {
    z-index: 1;
    padding: 12px 16px;
    margin: 0 !important;
  }
  .AcademicWorks_academic-work__fYqan .AcademicWorks_tabs-mobile__wrapper__x5kBj .ant-tabs-tabpane {
    padding: 0 16px !important;
  }
  .AcademicWorks_academic-work__fYqan .AcademicWorks_tabs-mobile__wrapper__x5kBj .ant-tabs-nav-wrap::before {
    box-shadow: none !important;
    content: "‹" !important;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90deg, rgb(255, 255, 255) 25%, rgba(255, 255, 255, 0) 100%);
  }
  .AcademicWorks_academic-work__fYqan .AcademicWorks_tabs-mobile__wrapper__x5kBj .ant-tabs-nav-wrap::after {
    box-shadow: none !important;
    content: "›" !important;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(-90deg, rgb(255, 255, 255) 25%, rgba(255, 255, 255, 0) 100%);
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyDetail/Components/AcademicWorks/AcademicWorks.module.scss","webpack://./src/App.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACChB;EACE,WAAA;ADEF;;ACgFA,wCAAA;AACA;EACE,oBAAA;EACA,yBAAA;AD7EF;AC+EE;EACE,8BAAA;EACA,6BAAA;EACA,+FAAA;EACA,4BAAA;EACA,2BAAA;AD7EJ;;ACiFA;EACE,oBAAA;EACA,yBAAA;AD9EF;;ACiFA,+BAAA;AACA;EACE;IACE,WAAA;ED9EF;ECgFA;IACE,SAAA;ED9EF;AACF;ACiFA;EACE;IACE,UAAA;IACA,wCAAA;ED/EF;ECiFA;IACE,UAAA;IACA,iCAAA;ED/EF;AACF;ACkFA;EACE,2FAAA;ADhFF;;AA1CE;EACE,aAAA;AA6CJ;AA3CE;EACE;IACE,wBAAA;EA6CJ;EA3CE;IACE,yBAAA;EA6CJ;EA5CI;ICNJ,gDAAA;IACA,mBAAA;EDqDA;ECnDA;IACE,4BAAA;IACA,gBAAA;EDqDF;EClDA;IACE,wBAAA;EDoDF;ECjDA;IACE,UAAA;IACA,kBAAA;IACA,oBAAA;EDmDF;EChDA;IACE,0BAAA;EDkDF;EC/CE;IACE,2BAAA;IACA,uBAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,uFAAA;EDiDJ;EC1CE;IACE,2BAAA;IACA,uBAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,wFAAA;ED4CJ;AACF","sourcesContent":["@import \"App.scss\";\n\n.academic-work {\n  .tabs-mobile {\n    display: none;\n  }\n  @media only screen and (max-width: 900px) {\n    .tabs-landscape {\n      display: none !important;\n    }\n    .tabs-mobile {\n      display: block !important;\n      &__wrapper {\n        @include antd-tab-mobile-wrapper;\n      }\n    }\n  }\n}\n","@import \"antd/dist/reset.css\";\n.App {\n  width: 100%;\n}\n\n@mixin antd-tab-mobile-wrapper {\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 0px 10px 0px;\n  border-radius: 10px;\n\n  :global(.ant-tabs-nav) {\n    border-radius: 10px 10px 0 0;\n    overflow: hidden;\n  }\n\n  :global(.ant-tabs-nav-operations) {\n    display: none !important;\n  }\n\n  :global(.ant-tabs-tab) {\n    z-index: 1;\n    padding: 12px 16px;\n    margin: 0 !important;\n  }\n\n  :global(.ant-tabs-tabpane) {\n    padding: 0 16px !important;\n  }\n  :global(.ant-tabs-nav-wrap) {\n    &::before {\n      box-shadow: none !important;\n      content: \"\\2039\" !important;\n      font-size: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: linear-gradient(\n        90deg,\n        rgb(255, 255, 255) 25%,\n        rgba(255, 255, 255, 0) 100%\n      );\n    }\n\n    &::after {\n      box-shadow: none !important;\n      content: \"\\203A\" !important;\n      font-size: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: linear-gradient(\n        -90deg,\n        rgb(255, 255, 255) 25%,\n        rgba(255, 255, 255, 0) 100%\n      );\n    }\n  }\n}\n\n@mixin mui-tab-mobile-wrapper {\n  padding: 16px;\n  background: #fff;\n  border: 1px solid var(--light-grey);\n  border-radius: 10px;\n  :global(.MuiTabs-root) {\n    position: relative;\n\n    :global(.MuiTabScrollButton-root) {\n      position: absolute;\n      top: 0;\n      height: 100%;\n      background-color: white;\n      z-index: 1;\n\n      &:first-child {\n        left: 0;\n      }\n\n      &:last-child {\n        right: 0;\n      }\n    }\n  }\n}\n\n/* Global Toast / Message enhancements */\n.ant-message {\n  top: 72px !important;\n  z-index: 99999 !important;\n\n  .ant-message-notice-content {\n    border-radius: 10px !important;\n    padding: 10px 18px !important;\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.08) !important;\n    font-size: 13.5px !important;\n    font-weight: 500 !important;\n  }\n}\n\n.ant-notification {\n  top: 72px !important;\n  z-index: 99999 !important;\n}\n\n/* Standalone Toast Keyframes */\n@keyframes toast-progress {\n  from {\n    width: 100%;\n  }\n  to {\n    width: 0%;\n  }\n}\n\n@keyframes toast-slide-in {\n  from {\n    opacity: 0;\n    transform: translateY(-10px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.animate-toast-in {\n  animation: toast-slide-in 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `AcademicWorks_App__ZfcEp`,
	"ant-message": `AcademicWorks_ant-message__53yWu`,
	"ant-message-notice-content": `AcademicWorks_ant-message-notice-content__oWcAc`,
	"ant-notification": `AcademicWorks_ant-notification__Ru6UB`,
	"animate-toast-in": `AcademicWorks_animate-toast-in__Zqtv4`,
	"toast-slide-in": `AcademicWorks_toast-slide-in__jC85O`,
	"academic-work": `AcademicWorks_academic-work__fYqan`,
	"tabs-mobile": `AcademicWorks_tabs-mobile__g89PO`,
	"tabs-landscape": `AcademicWorks_tabs-landscape__2CXQE`,
	"tabs-mobile__wrapper": `AcademicWorks_tabs-mobile__wrapper__x5kBj`,
	"toast-progress": `AcademicWorks_toast-progress__5ej4f`
};
export default ___CSS_LOADER_EXPORT___;
